import axios from 'axios';
import Page from '../js/lib/page';
import { trackImpression } from '../js/lib/analytics-helper';
import { pageNames } from '../js/lib/page-name-identifiers';
import { isShowOnlySearchLayoutEnabled, isBotExperienceEnabled } from './helper';

import * as types from '../js/contactUs/constants/ActionTypes';

/**
 * Innovation Guild: search only experiment. for channel steering call
 */
function receivedIDIContactOptionsError() {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR,
  };
}

function receivedResponseFromRisk(riskOptions) {
  return {
    type: types.RECEIVED_RESPONSE_FROM_RISK,
    payload: riskOptions,
  };
}

const searchOnlyFPTI = (status) => {
  let eventNameExp = '';
  if (isShowOnlySearchLayoutEnabled()) {
    eventNameExp = 'search-only-faq-exp';
  } else if (isBotExperienceEnabled()) {
    eventNameExp = 'search-only-bot-acitve-convo-exp';
  }

  const searchOnlyFpti = {
    id: Page.getFPTIPageId(),
    link: `${eventNameExp}|contact-options-${status}`,
    event_name: eventNameExp,
    page: pageNames.articlePage.pageName,
    pgrp: pageNames.articlePage.pageGroupName,
    e: 'ac',
  };
  trackImpression(searchOnlyFpti);
};

function updateUserSelection(topicId, topicName = '') {
  return (dispatch) => {
    if (topicId.length <= 0) topicId = 'GENPOOL';
    if (topicName.length <= 0) topicName = 'HELP_CENTER';
    return axios
      .post('/smarthelp/update-user-selection', {
        _csrf: Page.getCSRFtoken(),
        topicId,
        topicName,
      })
      .then((response) => {
        searchOnlyFPTI('success');
        dispatch(receivedResponseFromRisk((response.data || {}).channel_availability_decisions || {}));
      })
      .catch(() => {
        searchOnlyFPTI('failure');
        dispatch(receivedIDIContactOptionsError());
      });
  };
}

export default updateUserSelection;
